import DangerousIcon from '@mui/icons-material/Dangerous';
import { Box, Grid, Link, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Item, WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { useWorkspaceContext, useWorkspaceSKUContext } from '../../../context';

const WorkspaceExpireMsg = () => {
  const workspaceSKU = useWorkspaceSKUContext();
  const workspace = useWorkspaceContext();
  const [isExpired, setIsExpired] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      workspaceSKU?.expiryDate &&
      dayjs(workspaceSKU.expiryDate).diff(new Date(), 'd') < 0 &&
      (workspaceSKU.workspacePlan?.planCode === 'TRIAL' ||
        workspaceSKU.workspacePlan?.planCode === 'PRM' ||
        workspaceSKU.workspacePlan?.planCode === 'STD')
    ) {
      setIsExpired(true);
    }
  }, [workspaceSKU.expiryDate, workspaceSKU.workspacePlan?.planCode]);

  return (
    <>
      {isExpired && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Item sx={{ bgcolor: WsColors.Red300 }}>
              <Stack direction="row" spacing={2}>
                <Grid item xs={0.4}>
                  <DangerousIcon sx={{ color: WsColors.Red500, fontSize: '40px' }} />
                </Grid>
                <Grid item xs={8}>
                  <WsTypography bold variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                    Your Subscription Plan has expired.
                  </WsTypography>
                  {workspace.owns ? (
                    <Box mt={1}>
                      <WsTypography bold color={WsTypoColors.BLACK} display="inline">
                        Please
                      </WsTypography>
                      <Link
                        underline="none"
                        sx={{ color: WsColors.TheBlues900, ml: 0.6, mr: 0.6, fontWeight: 500 }}
                        onClick={() => navigate('/plan/purchase')}
                      >
                        recharge
                      </Link>
                      <WsTypography bold color={WsTypoColors.BLACK} display="inline">
                        your plan or contact
                      </WsTypography>
                      <Link
                        underline="none"
                        sx={{ color: WsColors.TheBlues900, ml: 0.6, mr: 0.6, fontWeight: 500 }}
                        href="mailto:sales@wisestep-inc.com"
                      >
                        sales@wisestep-inc.com
                      </Link>
                      <WsTypography bold color={WsTypoColors.BLACK} display="inline">
                        for renewing your subscription and restoring access to your account
                      </WsTypography>
                    </Box>
                  ) : (
                    <Box>
                      <WsTypography bold color={WsTypoColors.BLACK} display="inline">
                        Please ask your workspace owner to recharge the plan or contact
                      </WsTypography>
                      <Link
                        underline="none"
                        sx={{ color: WsColors.TheBlues900, ml: 0.6, mr: 0.6, fontWeight: 500 }}
                        href="mailto:sales@wisestep-inc.com"
                      >
                        sales@wisestep-inc.com
                      </Link>
                      <WsTypography bold color={WsTypoColors.BLACK} display="inline">
                        for any help
                      </WsTypography>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={2}>
                  {workspace.owns && (
                    <Box sx={{ float: 'right' }}>
                      <Button
                        sx={{ mt: 1.6, bgcolor: WsColors.Green500 }}
                        variant="contained"
                        onClick={() => navigate('/plan/purchase')}
                      >
                        Recharge
                      </Button>
                    </Box>
                  )}
                </Grid>
              </Stack>
            </Item>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default WorkspaceExpireMsg;
